export type RecurlyPlanCode = "personal" | "pro-monthly" | "pro-yearly" | "pro-trial";

// This must be kept in sync with LensLicenseCustomProtocolMapper
export const trialPlanCodes: RecurlyPlanCode[] = ["pro-trial"];
